import { inNextServer } from '@fabric-app/compat';
import { createLogger } from '@fabric-app/utils/logging/index';

const storageLogger = createLogger("Local Storage");
const isWeb = !inNextServer();
const createLocalStorage = (keyName) => {
  const key = `FABRIC_${keyName}`;
  return {
    set: (data) => {
      try {
        if (isWeb) {
          window.localStorage.setItem(key, JSON.stringify(data));
        } else {
          storageLogger.warn("Trying to access localStorage outside web. No data will be saved.");
        }
      } catch (e) {
        storageLogger.error("Local Storage Error", e);
      }
    },
    get: () => {
      try {
        if (isWeb) {
          try {
            return JSON.parse(window.localStorage.getItem(key) ?? "") ?? null;
          } catch {
            return null;
          }
        } else {
          storageLogger.warn("Trying to access localStorage outside web. Cannot read.");
          return null;
        }
      } catch (e) {
        storageLogger.error("Local Storage Error", e);
        return null;
      }
    },
    remove: () => {
      try {
        if (isWeb) {
          window.localStorage.removeItem(key);
        } else {
          storageLogger.warn("Trying to access localStorage outside web. No data will be saved.");
        }
      } catch (e) {
        storageLogger.error("Local Storage Error", e);
      }
    }
  };
};

export { createLocalStorage };
//# sourceMappingURL=localStorage.js.map
